









































// This component is typically used as a dynamic component inside ModalWrapperComponent

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TokenUser } from '../TokenUser';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import * as utils_tracker from '../utils_tracker';
import { globalUC } from '../UserCache';

@Component({
  name: 'EnableTelegramAlertsComponent',
  components: { 
   }
})
export default class EnableTelegramAlertsComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public telegramConfirmationCode: string = null    // held outside of user for safety
  public startedVerifyPolling: boolean = false
  public verified: boolean = false
  public aborted: boolean = false
  
  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public onCancel() {
    this.$store.commit('setLoading', { loading: false });
    this.$emit('close', false)
    this.aborted = true
  }
  public onOK() {
    this.$emit('close', true)
  }
  public clickedTelegramApp() {
    const url: string = 'https://telegram.org/'
    if (url) window.open(url, "_blank"); 
  }
  public clickedTelegramStartLink() {
    const url: string =  `https://telegram.me/livetoken_bot?start=${this.telegramConfirmationCode}`
    if (url) window.open(url, "_blank"); 
  }
  public async onVerify() {
    this.startedVerifyPolling = true
    this.$store.commit('setLoading', { loading: true });
    let failed: boolean = false
    while (!this.verified && !failed && this.user && !this.aborted) {
      // make GET call to server
      try {
        const url: string = utils.getURLprefix() + `/api/topshot/verifyTelegramAccount`

        const response: any = await utils.makeGetCall(url);
        if (!response || !response.data) throw(new Error('EnableTelegramAlertsComponent.onVerify() got null response or null response.data'))
        if (response.data.error) {
          this.$store.commit('setLoading', { loading: false });
          utils.toast(this, 'Error', response.data.error)
          failed = true
          break
        }

        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one

        this.verified = Boolean(response.data.verified)

        if (this.verified) utils_tracker.track('User Enabled Telegram Account', { email: user.email })

      } catch (error) {
        utils.toast(this, 'System Error', 'Could not verify account')
        if (this.$store.state.devmode) console.error(error);
        failed = true
        break
      }

      await utils.sleep(2000)
    }

    this.$store.commit('setLoading', { loading: false });
  }

  // Parents call this to show modal (use a ref to call child -- https://stackoverflow.com/questions/42632711/how-to-call-function-on-child-component-on-parent-events)
  public async onShow(dynamicProps: {}) {
    await this.getCode()
    if (!dynamicProps) return
  }

  public async getCode() {

    // make GET call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + `/api/topshot/linkTelegramAccount`

      const response: any = await utils.makeGetCall(url);
      if (!response || !response.data) throw(new Error('EnableTelegramAlertsComponent.getCode() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
      }

      if (response.data.user) {
        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one
      }

      this.telegramConfirmationCode = response.data.telegramConfirmationCode

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not get telegram code')
      if (this.$store.state.devmode) console.error(error);
    }

    this.$store.commit('setLoading', { loading: false });

  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    utils_tracker.track('User ClickedLinkTelegram', {})

  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
